import React from 'react';

import { Route } from 'helpers/routes/routes';
import { CommonPageData } from 'helpers/routes/CommonPageData';

export enum OrderRoute {
  Order = '/order',
}

const defaultCommonPageData: CommonPageData = {
  pageTitle: 'onecrm.common.pageTitle.order',
};

export const OrderRoutes: Route[] = [
  {
    path: OrderRoute.Order,
    exact: true,
    component: React.lazy(() => import('views/pages/Home/Home')),
    commonPageData: {
      ...defaultCommonPageData,
    },
  },
];
